import { useEffect, useState } from 'react';

/**
 * `true` when the viewport is at least 1024px wide. Subscribes to
 * matchMedia changes so layout flips are smooth across resize.
 *
 * Centralized in src/hooks (#65) — was duplicated 7× in TCN page files
 * with the exact same body. The 1024px breakpoint matches Tailwind's `lg`
 * which is what TCN layout shells switch on.
 */
const QUERY = '(min-width: 1024px)';

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' && window.matchMedia(QUERY).matches,
  );
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsDesktop(e.matches);
    mql.addEventListener?.('change', onChange);
    return () => mql.removeEventListener?.('change', onChange);
  }, []);
  return isDesktop;
};

export default useIsDesktop;
